import axiosApi from "../axiosApi"

class AppService {
  getVersion() {
    return axiosApi
      .get('api/login/version')
      .then(response => {
          console.log(response.data)
        if (response.data) {
            localStorage.removeItem('app-version');
            localStorage.setItem('app-version', response.data);
            return response.data;
        }
      });
  }
}

export default new AppService();
